import { EntityFeatureCategoryType } from "./entity-feature-category-type.model";
import { EntityFeature, EntityFeatureBase } from "./entity-feature.model";
import { EntityInfo, EntityInfoBase } from "./entity-info.model";
import { EntityStateType } from "./entity-state-type.model";
import { EntityType, EntityTypeBase } from "./entity-type.model";

export class EntityBase {
    id!: number;
    disabledDate!: Date;
    logoUrl!: string;
    state!: number;
    entityInfoId!: number;
    entityInfo!: EntityInfo;
    entityTypeId!: number;
    entityType!: EntityType;
    features: EntityFeature[] = [];

    stateToText(): string {
        switch (this.state) {
            case EntityStateType.active:
                return "Actiu"
            case EntityStateType.readonly:
                return "Lectura"
            case EntityStateType.inactive:
                return "Inactiu"
        }
        return "Desconegut";
    }

    findCategory(featureCategory: EntityFeatureCategoryType, defaultValue: string): EntityFeature {
        let feature: EntityFeature = new EntityFeatureBase();
        feature.category = featureCategory
        feature.entityId = this.id
        feature.value = defaultValue
        this.features.forEach(f => {
            if (f.category == featureCategory) {
                feature = f;
            }
        })

        return feature
    }

    isActive(): boolean {
        return this.state == EntityStateType.active
    }

    isReadOnly(): boolean {
        return this.state == EntityStateType.readonly
    }

    isInactive(): boolean {
        return this.state == EntityStateType.inactive
    }

    updateCategory(): void {

    }

    hasOU(): boolean {
        return this.features.find(f => f.category == EntityFeatureCategoryType.ORGANIZATIONAL_UNIT)?.value == "true"
    }

    hasSarcat(): boolean {
        return this.features.find(f => f.category == EntityFeatureCategoryType.SARCAT)?.value == "true"
    }

    hasInbox(): boolean {
        return this.features.find(f => f.category == EntityFeatureCategoryType.INBOX)?.value == "true"
    }

    isPromoter(): boolean {
        return this.features.find(f => f.category == EntityFeatureCategoryType.PROMOTER)?.value == "true"
    }

    hasRedo(): boolean {
        return this.features.find(f => f.category == EntityFeatureCategoryType.REDO)?.value == "true"
    }

    static fromEntity(entity: Entity): EntityBase {
        let current = new EntityBase();
        Object.assign(current, entity)

        if (entity.entityInfo != null) {
            current.entityInfo = EntityInfoBase.fromEntityInfo(entity.entityInfo)
        }
        if (entity.entityType != null) {
            current.entityType = EntityTypeBase.from(entity.entityType)
        }
        if (entity.features != null) {
            current.features = []
            entity.features.forEach(f => {
                current.features.push(EntityFeatureBase.fromEntityFeature(f))
            })
            current.features.sort(EntityFeatureBase.cmp)
        }

        return current;
    }
}

export interface Entity extends EntityBase {

}



